import _ from 'lodash'

const order = ['Temperature', 'Humidity']

export default ({ readingType: { name } }) => {
  if (!_.includes(order, name)) return 1000

  return _.indexOf(order, name)
}
